export const storyItemsSelector = (state) => state.story.story;
export const pagesListLoadingSelector = (state) => state.story.loading;
